const q = require('queried');
const on = require('emmy/on');
const find = require('lodash/find');

/**
 * Bind handler for instagram iframe height messages
 *
 * We have to replace their src with data-src temporarily,
 * because otherwise iframe could be already loaded when we begin to listen to messages
 *
 * Note, that the function is used both in admin and user interface
 */
function bindInstagramIframes() {
  on(window, 'message', (event) => {
    if (event.origin !== 'https://www.instagram.com') {
      return;
    }

    /**
     * Note that we use 'src' attribute here instead of 'data-src',
     * because we already replaced the attributes by the moment
     *
     * Also we can't use object literal parameter for 'find' here
     * (e.g. `find(iframes, { contentWindow: event.source })`),
     * because it causes "Blocked a frame ... from accessing a cross-origin frame" error here
     */
    const iframe = find(q.all('iframe[src*="instagram"]'), (i) => i.contentWindow === event.source);

    if (!iframe) {
      return;
    }

    const data = JSON.parse(event.data);

    if (data.type === 'MEASURE') {
      iframe.style.height = `${data.details.height}px`;
    }
  });
}

/**
 * Replace data-src with src for all the instagram widgets on the page
 * This function is necessary for newly added instagram widgets to function properly
 */
function launchInstagramWidgets() {
  q.all('iframe[data-src*="instagram"]').forEach(
    (i) => {
      i.setAttribute('src', i.getAttribute('data-src'));
      // remove data-src so the iframe won't be reloaded on next function call
      i.removeAttribute('data-src');
    },
  );
}

module.exports = {
  bindInstagramIframes,
  launchInstagramWidgets,
};
